(() => {
  // Minimal review patch for Viva:
  // - Keep Judge.me product reviews exactly as they are.
  // - Do not filter by verified/unverified status.
  // - Do not alter ratings, summaries, histograms, or structured data.
  // - Only remove the legacy Viva empty-state notice.

  const noticeText = 'No verified customer reviews yet. Be the first to share your experience.';

  function removeLegacyNotice(scope = document) {
    scope.querySelectorAll('.viva-review-empty').forEach((node) => node.remove());

    scope.querySelectorAll('.jdgm-rev-widg p, .jdgm-rev-widg div, .jdgm-rev-widg span').forEach((node) => {
      if (node.children.length === 0 && node.textContent.trim() === noticeText) {
        node.remove();
      }
    });
  }

  const style = document.createElement('style');
  style.textContent = '.viva-review-empty{display:none!important;}';
  document.head.appendChild(style);

  document.addEventListener('DOMContentLoaded', () => removeLegacyNotice(), { once: true });

  let timer;
  new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(() => removeLegacyNotice(), 80);
  }).observe(document.documentElement, { childList: true, subtree: true });

  setTimeout(() => removeLegacyNotice(), 800);
  setTimeout(() => removeLegacyNotice(), 2000);
})();
